module.exports = __webpack_public_path__ + "static/media/profile picture.d90bd8d7.jpg";